module.exports = "/_next/static/images/property-mobile@3x-54e0a1c5a45101073db2ac595b8c28c7.png";